module.exports = __webpack_public_path__ + "img/erptitleNew.f77d19fe.jpg";